// frontend/src/farm/farmCursor.mjs
// Over the garden the mouse cursor becomes the tool a click would use — no hover text:
//   hoe (plow grass / fallow) · seed bag (plant, or pick seeds, on plowed soil) ·
//   sickle (harvest a ripe crop) · hourglass (still growing) · an open hand over a placed object
//   (a click opens its menu: move, flip, pick up, sell). Off the farm: the normal cursor.
// Icons: frontend/public/assets/farm/cursors/cursor_<name>.png (40 px) and @2x (80 px),
// cut by scripts/farm_cursors.py. Pure (node --test).

// Hotspot of each 40 px icon: the tool's working tip, where the click lands.
export const CURSORS = {
  plow: [4, 9],      // the lower corner of the hoe blade
  plant: [4, 5],     // the seeds spilling from the bag
  harvest: [2, 6],   // the sickle's point
  wait: [20, 20],    // the hourglass has no tip: its middle
  object: [12, 2],   // the open hand (icons/hand.png, drawn 26 px): its middle fingertip
  tractor: [20, 30], seeder: [20, 30], harvester: [20, 30],   // a vehicle: under its wheels
  recycle: [6, 30],  // Zasyp: the shovel blade's tip (icons/shovel.png, blade down-left)
  konewka: [35, 20], // the Konewka on a friend's farm (scripts/farm_vehicles.py): the spout's rose, where the water falls
};

export function cursorFor(stage, tool = 'hand') {
  if (!stage) return null;
  if (typeof tool === 'string' && tool !== 'hand') return tool;   // a picked vehicle is the cursor everywhere
  if (stage === 'object') return 'object';
  if (stage === 'grass' || stage === 'fallow') return 'plow';
  if (stage === 'plowed') return 'plant';
  if (stage === 'ready') return 'harvest';
  return 'wait';
}

// CSS for `canvas.style.cursor`. `imageSet` gives retina screens the 2× icon; browsers that
// reject it keep `plain`, which is set first. `pointer` is the fallback if the image fails.
export function cursorCss(name, base) {
  if (!name) return { plain: '', imageSet: '' };
  const [x, y] = CURSORS[name];
  const one = `url("${base}/cursor_${name}.png")`;
  const two = `url("${base}/cursor_${name}@2x.png")`;
  return {
    plain: `${one} ${x} ${y}, pointer`,
    imageSet: `image-set(${one} 1x, ${two} 2x) ${x} ${y}, pointer`,
  };
}
